import React from 'react';
import PropTypes from 'prop-types';
import PaymentMethodIcon from '../PayManually/PaymentMethodIcon';
import { Creditcards } from 'creditcards-info';
import styles from './CreditCardLine.scss';
import { translate } from 'react-i18next';
import { Text } from 'wix-style-react';

function CreditCardLine({ lastDigits, network, holderName, locale, block, className, collectionMethod, t }) {
  let text;

  if (collectionMethod === 'phone') {
    text = t('phoneordering_checkout_paymentmethod_card_title');
  } else if (collectionMethod === 'cod') {
    text = t('phoneordering_checkout_paymentmethod_card_delivery_title');
  } else {
    text = `${holderName} (${Creditcards.getCreditcardName(locale, network)} ending in ${lastDigits})`;
  }

  return (
    <Text
      size="small"
      weight="normal"
      secondary
      tagName={block ? 'div' : 'span'}
      className={`${className} ${styles.text}`}
      data-hook="credit-card-line"
    >
      <PaymentMethodIcon type={network} size={30} className={styles.svg} />
      {text}
    </Text>
  );
}

CreditCardLine.displayName = 'CreditCardLine';
CreditCardLine.propTypes = {
  lastDigits: PropTypes.string,
  network: PropTypes.string,
  holderName: PropTypes.string,
  block: PropTypes.bool,
  locale: PropTypes.string,
  className: PropTypes.string,
  collectionMethod: PropTypes.oneOf(['online', 'cod', 'phone']).isRequired,
  t: PropTypes.func,
};

export default translate()(CreditCardLine);
